var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinciplesMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    fill: "#F4F4F4",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m361 226c0-57.9-47.1-105-105-105s-105 47.1-105 105 47.1 105 105 105 105-47.1 105-105zm-175.499 10.499 20.999-21 34.501 34.2 64.501-64.2 20.999 21-85.501 85.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 512 4.2-1.201c9-2.399 220.8-67.599 220.8-434.799v-15h-15c-99.901 0-201.599-56.501-202.8-57.1l-7.2-3.9-7.2 3.9c-1.201.599-102.899 57.1-202.8 57.1h-15v15c0 367.2 211.8 432.4 220.8 434.799zm-135-286c0-74.401 60.601-135 135-135s135 60.599 135 135c0 74.399-60.601 135-135 135s-135-60.601-135-135z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinciplesMenu);
export default __webpack_public_path__ + "static/media/principlesMenu.8e87e72aa7b00c48d049d550bd23834a.svg";
export { ForwardRef as ReactComponent };